<template>
    <div>
        <section
            v-for="(section, title) in configuration"
            :key="title"
            class="section"
            @click="activeDropdown = undefined"
        >
            <h1 v-t="`project.settings.${title}_title`" class="title is-4"></h1>
            <div v-for="(value, option) in section" :key="option" class="box">
                <div class="level">
                    <div class="level-left">
                        <div class="level-item">
                            <div>
                                <p
                                    v-t="`project.settings.${option}`"
                                    class="title is-6"
                                ></p>

                                <p
                                    class="
                                        is-size-7 is-italic
                                        has-text-grey
                                        pt-1
                                    "
                                >
                                    {{
                                        $t(
                                            `project.settings.${option}_description`
                                        )
                                    }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="level-right">
                        <div class="level-item">
                            <label
                                v-if="typeof value === 'boolean'"
                                class="switch"
                            >
                                <input
                                    v-model="activeConfiguration[title][option]"
                                    type="checkbox"
                                />
                                <span class="slider round"></span>
                            </label>
                            <div
                                v-else
                                :class="{
                                    'is-active': option == activeDropdown,
                                }"
                                class="dropdown"
                            >
                                <div
                                    class="dropdown-trigger"
                                    @click.stop="activeDropdown = option"
                                >
                                    <button
                                        class="button"
                                        aria-haspopup="true"
                                        aria-controls="dropdown-menu"
                                    >
                                        <span>
                                            {{
                                                $t(
                                                    `Constants.${activeConfiguration[title][option]}`
                                                ) || $t('Buttons.select')
                                            }}
                                        </span>
                                        <span class="icon is-small">
                                            <i
                                                class="fas fa-angle-down"
                                                aria-hidden="true"
                                            ></i>
                                        </span>
                                    </button>
                                </div>
                                <div
                                    id="dropdown-menu"
                                    class="dropdown-menu"
                                    role="menu"
                                >
                                    <div class="dropdown-content">
                                        <a
                                            v-for="constant in value"
                                            :key="constant"
                                            v-t="`Constants.${constant}`"
                                            class="dropdown-item"
                                            @click="
                                                activeConfiguration[title][
                                                    option
                                                ] = constant
                                            "
                                        ></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import _ from 'underscore';
export default {
    data() {
        return {
            activeDropdown: undefined,
            configuration: {
                global: {
                    thread: ['ALL', 'ONLY_ADMINISTRATORS', 'NONE'],
                    comments: false,
                    order: ['FORWARD', 'REVERSE'],
                    likes: false,
                },
                /* mailing: {
          new_object: false,
          new_comment: false,
          report_frequency: ["NONE", "1D", "3D", "1W", "1M"]
        }*/
            },
            activeConfiguration: {},
        };
    },
    computed: {
        projectConfiguration() {
            return JSON.parse(
                JSON.stringify(this.$store.getters.project.configuration)
            );
        },
    },
    watch: {
        activeConfiguration: {
            deep: true,
            handler() {
                this.$emit('update', this.activeConfiguration);
            },
        },
    },
    beforeMount() {
        this.activeConfiguration = _.extend(
            this.$store.state.defaultProjectConfiguration,
            this.projectConfiguration
        );
    },
};
</script>

<style></style>
